const state = {
  authInfo: {}
}

const mutations = {
  seAuthInfo (state, data) { 
    state.authInfo = data
  },
};

const actions = {
  seAuthInfo (context, data) {
    context.commit('seAuthInfo', data)
  },
};

export default {
  state,
  mutations,
  actions
}